/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IngredientSource } from "./IngredientSource";
export type CompositionUpdate = {
  id: string;
  substance_id?: string;
  amount_pct_lower?: number;
  amount_pct_upper?: number;
  cas_numbers?: Array<string>;
  ec_numbers?: Array<string>;
  functions?: Array<string>;
  ingredient_sources?: Array<IngredientSource>;
  country_of_origin?: Array<string>;
  calculation_method?: string;
  unset?: CompositionUpdate.unset;
  index?: number;
};
export namespace CompositionUpdate {
  export enum unset {
    CALCULATION_METHOD = "calculation_method",
  }
}
